// eslint-disable-next-line
﻿'use strict';

import React, { Component } from 'react';
import DetalleApoderadoTarjeta from './DetalleApoderadoTarjeta';
import Tarjetas from './Tarjetas';

const PantallaActual = ({ pantalla, data, cuenta, cuentaTitular, tarjetaActual, getExisteSolicitudCuenta, state, borrarTarjeta, plasticos, reimprimirTarjeta, reimprimirPin, modificarSolicitud, mostrarAlertaProcesoFinalizado, agregarQuitarCuentaVinculo, grabarVinculacion, cambiarCuentaPrincipal, GetVinculosByNroTarjeta, mostrarVinculos, getHistorialMovimiento, crearModificarSolicitudTarjeta, getSolicitudesTarjetaByTarjetaId, UserId, getVinculaciones, borrarVinculo, mostrarOcultarModalVinculos }) => {

    if (pantalla === 'detalleApoderado')
        return <DetalleApoderadoTarjeta
            tarjetaActual={tarjetaActual}
            plasticos={plasticos}
            data={data}
            cuenta={cuenta}
            getExisteSolicitudCuenta={getExisteSolicitudCuenta}
            state={state}
            borrarTarjeta={borrarTarjeta}
            reimprimirTarjeta={reimprimirTarjeta}
            reimprimirPin={reimprimirPin}
            modificarSolicitud={modificarSolicitud}
            mostrarAlertaProcesoFinalizado={mostrarAlertaProcesoFinalizado}
            agregarQuitarCuentaVinculo={agregarQuitarCuentaVinculo}
            grabarVinculacion={grabarVinculacion}
            cambiarCuentaPrincipal={cambiarCuentaPrincipal}
            GetVinculosByNroTarjeta={GetVinculosByNroTarjeta}
            mostrarVinculos={mostrarVinculos}
            getHistorialMovimiento={getHistorialMovimiento}
            crearModificarSolicitudTarjeta={crearModificarSolicitudTarjeta}
            getSolicitudesTarjetaByTarjetaId={getSolicitudesTarjetaByTarjetaId}
            UserId={UserId}
            getVinculaciones={getVinculaciones}
            borrarVinculo={borrarVinculo}
            mostrarOcultarModalVinculos={mostrarOcultarModalVinculos}
        />;
    else
        return (
            <Tarjetas
                tarjetaActual={tarjetaActual}
                plasticos={plasticos}
                data={data}
                borrarTarjeta={borrarTarjeta}
                cuenta={cuenta}
                cuentaTitular={cuentaTitular}
                mostrarAlertaProcesoFinalizado={mostrarAlertaProcesoFinalizado}
                agregarQuitarCuentaVinculo={agregarQuitarCuentaVinculo}
                getVinculaciones={getVinculaciones}
            />
        );
}

const ScreenLinkButton = ({ text, screenChangeFn, currentScreen, screenName }) => {
    if (currentScreen === screenName)
        return (
            <div style={{ marginLeft: '13px' }}>
                <label className="label-secondary">
                    {text}
                    <i className="glyphicon glyphicon-menu-right"></i>
                </label>
            </div>
        );
    else {
        return (
            <div>
                <button className="btn btn-link label-secondary" onClick={() => screenChangeFn(screenName)}>
                    {text}
                </button>
            </div>
        );
    }
};

class DetalleCuenta extends Component {

    constructor(props) {
        super(props);
        let pantallaInicial = 'general';

        if (this.props.pantalla === "detalleApoderado")
            pantallaInicial = 'detalleApoderado';

        this.state = { pantallaActual: pantallaInicial };
    }

    cambiarPantallaActual(pantalla) {
        this.setState({ pantallaActual: pantalla });
    }

    render() {

        const cuenta = this.props.cuenta;
        const tarjetaActual = this.props.tarjeta;


        //const cuentaTitular = cuenta.children.find(x => x.titular === true);
        const cuentaTitular = { tarjeta: this.props.plasticos.tarjetas.find(x => x.id_plastico == tarjetaActual.id_plastico).DescripcionProducto };
        const tarjetaNombre = cuentaTitular.tarjeta;

        return (
            <div style={{ marginTop: '50px' }}>

                <div style={{ display: 'inline-flex' }}>

                    <div className="DatosMenuContainer">

                        <div className="div-volver-al-listado">
                            <button className="btn btn-link label-secondary" onClick={() => this.props.cambiarPantalla('listado')}>
                                <i className="glyphicon glyphicon-menu-left "></i>
                                Volver al listado
                     </button>
                        </div>

                        <div className="div-cuenta-detalle">
                            <p><strong>{cuenta.cuentas}</strong></p>
                            <p>{cuenta.numero}</p>
                        </div>

                        <div className="div-menu-cuenta-tarjeta1">
                            <div className="div-menu-cuenta-tarjeta2">
                                <p>
                                    <i className="glyphicon glyphicon-triangle-bottom"></i>
                                    {tarjetaNombre}
                                </p>
                            </div>
                            <ScreenLinkButton
                                text="Tarjetas"
                                currentScreen={this.state.pantallaActual}
                                screenName='tarjetas'
                                screenChangeFn={this.cambiarPantallaActual.bind(this)}
                            />
                        </div>

                    </div>
                    <div className="DatosPantallaContainer">
                        <PantallaActual
                            pantalla={this.state.pantallaActual}
                            data={this.props.data}
                            plasticos={this.props.plasticos}
                            cuenta={this.props.cuenta}
                            tarjetaActual={tarjetaActual}
                            cuentaTitular={cuentaTitular}
                            getExisteSolicitudCuenta={this.props.getExisteSolicitudCuenta}
                            state={this.props.state}
                            borrarTarjeta={this.props.borrarTarjeta}
                            reimprimirTarjeta={this.props.reimprimirTarjeta}
                            reimprimirPin={this.props.reimprimirPin}
                            modificarSolicitud={this.props.modificarSolicitud}
                            mostrarAlertaProcesoFinalizado={this.props.mostrarAlertaProcesoFinalizado}
                            agregarQuitarCuentaVinculo={this.props.agregarQuitarCuentaVinculo}
                            grabarVinculacion={this.props.grabarVinculacion}
                            cambiarCuentaPrincipal={this.props.cambiarCuentaPrincipal}
                            GetVinculosByNroTarjeta={this.props.GetVinculosByNroTarjeta}
                            mostrarVinculos={this.props.mostrarVinculos}
                            getHistorialMovimiento={this.props.getHistorialMovimiento}
                            crearModificarSolicitudTarjeta={this.props.crearModificarSolicitudTarjeta}
                            getSolicitudesTarjetaByTarjetaId={this.props.getSolicitudesTarjetaByTarjetaId}
                            UserId={this.props.UserId}
                            getVinculaciones={this.props.getVinculaciones}
                            borrarVinculo={this.props.borrarVinculo}
                            mostrarOcultarModalVinculos={this.props.mostrarOcultarModalVinculos}
                        />
                    </div>

                </div>

            </div>
        );

    }

}

export default DetalleCuenta;
